import styled from 'styled-components';
import { Avatar } from '@mui/material';


const ChatWindowAvatar = styled(Avatar)`
    margin-right: 12px;
`;

const MessageContainer = styled.div`
    margin-bottom: 12px;
    display: flex;
    width: ${props => props.width || '60%'};
`;

const MessageWrapper = styled.div`
    padding: 12px;
    border-radius: 12px;
    width: 100%;
    background-color: ${props => props.itemType === 'sent' ? props.theme.colors.greySix : props.theme.colors.white || '#FFFFFF'};
    color: ${props => props.theme.colors.black };
    margin-bottom: 5px;

    > * {
        margin: 0;
    }

    .markdown-content, .html-content {
        width: 100%;
        overflow-x: auto;
        
        table {
            border-collapse: collapse;
            width: 100%;
            margin: 8px 0;
        }

        th, td {
            border: 1px solid ${props => props.theme.colors.lightGrey};
            padding: 8px;
            text-align: left;
        }

        th {
            background-color: ${props => props.theme.colors.culturedGray};
        }

        pre {
            background-color: ${props => props.theme.colors.culturedGray};
            padding: 1em;
            border-radius: 6px;
            overflow-x: auto;
        }

        code {
            background-color: ${props => props.theme.colors.culturedGray};
            padding: 0.2em 0.4em;
            border-radius: 3px;
            font-family: monospace;
        }

        p {
            margin: 0.5em 0;
        }

        ul, ol {
            margin: 1em 0;
            padding-left: 2em;
        }

        li {
            margin: 0.5em 0;
        }
    }
`;

const MessageButtonsWrapper = styled.div`
    display: flex;
    gap: 10px;
    margin-top: ${props => props.mt ||'20px'};
    align-items: center;

    a {
        cursor: pointer;
    }
`;

const EditMessageWrapper = styled.div`
    padding: 12px;
    border-radius: 12px;
    width: 100%;
    color: ${props => props.theme.colors.black};
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 30px;

    > * {
        margin: 0;
    }
`;

const EditMessageText = styled.div`
    ${props => props.theme.fonts.variant.light};
    font-size: ${props => props.theme.fonts.size.medium};
    color: ${props => props.theme.colors.black};
    text-align: center;
`;

const EditMessageInput = styled.textarea`
    resize: none;
    padding: 5px 10px;
    border-radius: 10px;

    &:focus {
        outline: none;
    }
`
const EditMessageInputWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    color: ${props => props.theme.colors.black};
`;

export {
  ChatWindowAvatar,
  MessageContainer,
  MessageWrapper,
  MessageButtonsWrapper,
  EditMessageWrapper,
  EditMessageText,
  EditMessageInput,
  EditMessageInputWrapper
}
